(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jvv-gift-progress"] && !Shopify.designMode) return;
  try {
    (function(){
  function update(cart){
    document.querySelectorAll('[data-jvv-gifts]').forEach(el=>{
      if(cart && cart.currency){el.hidden=cart.currency!=='EUR';}
      const total=cart?cart.total_price:Number(el.dataset.total);
      if(!Number.isFinite(total))return;
      const tiers=[...el.querySelectorAll('[data-gift-tier]')];
      const text=JSON.parse(el.querySelector('[data-gift-text]').textContent);
      const reached=tiers.filter(t=>total>=Number(t.dataset.giftTier));
      const current=reached.at(-1);
      const next=tiers.find(t=>total<Number(t.dataset.giftTier));
      tiers.forEach(t=>{t.classList.toggle('is-reached',reached.includes(t));t.classList.toggle('is-current',t===current);});
      el.querySelector('progress').value=Math.min(total,15000);
      el.querySelector('[data-gift-message]').textContent=next?text.next.replace('{amount}',new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:'EUR'}).format((Number(next.dataset.giftTier)-total)/100)).replace('{gift}',next.querySelector('span').textContent):text.max;
      el.querySelector('[data-gift-earned]').textContent=current?text.earned.replace('{gift}',current.querySelector('span').textContent):'';
    });
  }
  update();
  document.addEventListener('theme:cart:change',event=>{if(event.detail && event.detail.cart)update(event.detail.cart);});
  document.addEventListener('shopify:section:load',()=>update());
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jvv-gift-suggestions"] && !Shopify.designMode) return;
  try {
    (() => {
    const SLOTS = 5;
    let lastCart;
    const update = (cart) => {
      if (cart) lastCart = cart;
      document.querySelectorAll('[data-jvv-suggestions]').forEach((root) => {
        const text = JSON.parse(root.querySelector('[data-suggestion-text]').textContent);
        const total = lastCart ? lastCart.total_price : Number(root.dataset.total);
        const currency = lastCart ? lastCart.currency : root.dataset.currency;
        const index = [4500,7500,11000,15000].findIndex((tier) => total < tier);
        root.hidden = index < 0 || currency !== 'EUR' || total === 0;
        if (root.hidden) return;
        const gap = [4500,7500,11000,15000][index] - total;
        const money = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:'EUR'}).format(amount / 100);
        root.querySelector('[data-suggestion-message]').textContent = text.next.replace('{amount}',money(gap)).replace('{gift}',text.gifts[index]);
        const items = lastCart ? lastCart.items.map((item) => item.product_id) : text.items;
        const cards = [...root.querySelectorAll('[data-suggestion-product]')].filter((card) => card.querySelector('select').options.length > 0);
        cards.forEach((card) => { card.hidden = true; card.removeAttribute('data-rank'); card.querySelector('[data-suggestion-price]').textContent = money(Number(card.querySelector('select').selectedOptions[0].dataset.price)); });
        const price = (card) => Math.min(...[...card.querySelector('select').options].map((o) => Number(o.dataset.price)));
        const score = (card) => price(card) >= gap ? price(card) - gap : gap + (gap - price(card));
        const ranked = cards.filter((card) => !items.includes(Number(card.dataset.suggestionProduct))).sort((a,b) => score(a)-score(b));
        const picked = [];
        const usedTypes = new Set();
        ranked.forEach((card) => { if (picked.length < SLOTS && !usedTypes.has(card.dataset.suggestionType)) { picked.push(card); usedTypes.add(card.dataset.suggestionType); } });
        ranked.forEach((card) => { if (picked.length < SLOTS && !picked.includes(card)) picked.push(card); });
        const grid = root.querySelector('.jvv-suggestions__grid');
        picked.forEach((card, i) => { card.hidden = false; card.dataset.rank = i + 1; grid.append(card); });
        root.hidden = picked.length === 0;
      });
    };
    document.addEventListener('theme:cart:change', (event) => update(event.detail && event.detail.cart));
    document.addEventListener('shopify:section:load', () => update());
    document.addEventListener('change', (event) => { if (event.target.matches('[data-suggestion-variant]')) update(); });
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-suggestion-add]');
      if (!button || button.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      const root = button.closest('[data-jvv-suggestions]');
      const card = button.closest('[data-suggestion-product]');
      button.disabled = true;
      root.querySelector('[data-suggestion-error]').hidden = true;
      try {
        const response = await fetch((window.Shopify.routes.root || '/') + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(card.querySelector('select').value),quantity:1}]})});
        if (!response.ok) throw new Error('Cart add failed');
        window.location.assign((window.Shopify.routes.root || '/') + 'cart');
      } catch (error) {
        root.querySelector('[data-suggestion-error]').hidden = false;
        button.disabled = false;
      }
    }, true);
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jvv-gift-wrap"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = () => document.querySelector('[data-jvv-wrap]');
    const base = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const send = async (button, url, body) => {
      const box = button.closest('[data-jvv-wrap]');
      const status = box.querySelector('[data-jvv-wrap-status]');
      box.querySelectorAll('button').forEach((b) => { b.disabled = true; });
      status.textContent = 'Mise à jour…';
      try {
        const response = await fetch(base() + url, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
        if (!response.ok) throw new Error('request failed');
        window.location.assign(base() + 'cart');
      } catch (error) {
        status.textContent = 'La mise à jour n\'a pas pu se faire. Veuillez réessayer.';
        box.querySelectorAll('button').forEach((b) => { b.disabled = false; });
      }
    };
    document.addEventListener('click', (event) => {
      const add = event.target.closest('[data-jvv-wrap-add]');
      const remove = event.target.closest('[data-jvv-wrap-remove]');
      if (!add && !remove) return;
      if ((add || remove).disabled) return;
      event.preventDefault();
      event.stopPropagation();
      if (add) {
        const box = add.closest('[data-jvv-wrap]');
        send(add, 'cart/add.js', {items: [{id: Number(box.dataset.variant), quantity: 1, properties: {'Article à emballer': add.dataset.article}}]});
      } else {
        send(remove, 'cart/change.js', {id: remove.dataset.key, quantity: Number(remove.dataset.qty)});
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jvv-grand-jeu"] && !Shopify.designMode) return;
  try {
    (() => {
  const state = new WeakMap();
  const st = (root) => { if (!state.has(root)) state.set(root, { saving: null, warned: false }); return state.get(root); };
  const texts = (root) => JSON.parse(root.querySelector('[data-jvv-game-text]').textContent);
  const el = (root, sel) => root.querySelector(sel);

  // Un consentement n'est valide que si les DEUX cases sont cochées. Sinon, les attributs sont vidés
  // (Shopify supprime un attribut de valeur vide) : aucun consentement n'est conservé.
  function values(root) {
    const p = el(root, '[data-jvv-game-participate]').checked;
    const a = el(root, '[data-jvv-game-accept]').checked;
    const valid = p && a;
    return {
      valid, half: p !== a,
      attributes: {
        'Grand Jeu JVV - operation': valid ? 'grand-jeu-jvv-2026-11' : '',
        'Grand Jeu JVV - participation': valid ? 'Oui' : '',
        'Grand Jeu JVV - reglement': valid ? root.dataset.version : '',
        'Grand Jeu JVV - horodatage': valid ? new Date().toISOString() : '',
      },
    };
  }
  function syncHidden(root, attributes) {
    const map = { operation: 'Grand Jeu JVV - operation', participation: 'Grand Jeu JVV - participation', reglement: 'Grand Jeu JVV - reglement', horodatage: 'Grand Jeu JVV - horodatage' };
    root.querySelectorAll('[data-jvv-field]').forEach((input) => { input.value = attributes[map[input.dataset.jvvField]]; });
  }
  function message(root, v) {
    const t = texts(root);
    if (root.dataset.mode === 'simulation') return v.valid ? t.test_saved : (v.half ? t.accept : t.declined);
    return v.valid ? t.saved : (v.half ? t.accept : t.declined);
  }
  async function save(root) {
    const s = st(root), v = values(root);
    const status = el(root, '[data-jvv-game-status]'), retry = el(root, '[data-jvv-game-retry]');
    s.warned = false;
    if (root.dataset.mode === 'simulation') { status.textContent = message(root, v); return; }
    syncHidden(root, v.attributes);
    retry.hidden = true;
    status.textContent = texts(root).saving;
    const run = (async () => {
      const r = await fetch((window.Shopify.routes.root || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: v.attributes }) });
      if (!r.ok) throw new Error('save');
      const cart = await r.json();
      for (const [k, val] of Object.entries(v.attributes)) if ((cart.attributes[k] || '') !== val) throw new Error('verify');
    })();
    s.saving = run;
    try { await run; status.textContent = message(root, v); }
    catch (e) { status.textContent = texts(root).error; retry.hidden = false; }
    finally { if (s.saving === run) s.saving = null; }
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-jvv-game-participate],[data-jvv-game-accept]')) return;
    const root = event.target.closest('[data-jvv-grand-jeu]');
    event.stopPropagation();
    save(root);
  }, true);

  document.addEventListener('click', (event) => {
    const retry = event.target.closest('[data-jvv-game-retry]');
    if (retry) { event.preventDefault(); save(retry.closest('[data-jvv-grand-jeu]')); return; }
    if (event.target.closest('[name="checkout"],[data-cart-checkout],a[href*="/checkout"]')) guard(event);
  }, true);
  document.addEventListener('submit', (event) => {
    if (event.target.matches('form[action*="/cart"]')) guard(event);
  }, true);

  // Ne bloque JAMAIS un client qui ne participe pas. Seul cas d'arrêt (une fois) : une seule case cochée,
  // pour éviter qu'un client croie participer. Au 2e clic, la commande part sans participation.
  function guard(event) {
    for (const root of document.querySelectorAll('[data-jvv-grand-jeu]')) {
      const v = values(root), s = st(root);
      if (root.dataset.mode !== 'simulation') syncHidden(root, v.attributes);
      if (v.half && !s.warned) {
        s.warned = true;
        event.preventDefault(); event.stopImmediatePropagation();
        el(root, '[data-jvv-game-status]').textContent = texts(root).accept;
        root.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
    }
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jvv-stickers-option"] && !Shopify.designMode) return;
  try {
    (() => {
    let saving = false;
    document.addEventListener('change', async (event) => {
      const checkbox = event.target;
      if (!checkbox.matches('[data-stickers-checkbox]')) return;
      event.stopPropagation();
      const root = checkbox.closest('[data-jvv-stickers]');
      const status = root.querySelector('[data-stickers-status]');
      const text = JSON.parse(root.querySelector('[data-stickers-text]').textContent);
      const checked = checkbox.checked;
      saving = true;
      checkbox.disabled = true;
      status.textContent = text.saving;
      try {
        const response = await fetch((window.Shopify.routes.root || '/') + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Stickers gratuits':checked ? 'Oui' : ''}})});
        if (!response.ok) throw new Error('Could not save preference');
        const cart = await response.json();
        if ((cart.attributes['Stickers gratuits'] === 'Oui') !== checked) throw new Error('Preference mismatch');
        status.textContent = text.saved;
      } catch (error) {
        checkbox.checked = !checked;
        status.textContent = text.error;
      } finally {
        saving = false;
        checkbox.disabled = false;
      }
    }, true);
    document.addEventListener('submit', (event) => {
      if (saving && event.target.querySelector('[data-jvv-stickers]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    document.addEventListener('click', (event) => {
      if (saving && event.target.closest('[name="checkout"], [data-cart-checkout], a[href*="/checkout"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
